import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getCompany } from './company.selectors';

export const getLicensedStates = createSelector(getCompany, ({ licensedStates }) => {
  if (Object.entries(licensedStates).length === 0) {
    return licensedStates;
  }

  return Object.entries(licensedStates).reduce(
    (acc, [key, license]) => ({
      ...acc,
      [key]: {
        id: license.id,
        stateCode: license.state.abbreviation,
        stateLicenseNumber: license.licenseNumber,
        companyName: license.companyName,
        licenseStartDate: license.terms.startDate,
        licenseExpireDate: license.terms.expirationDate,
        isRetailAllowed: license.isRetailAllowed,
        isWholesaleAllowed: license.isWholesaleAllowed,
        isNoQualifiedMortgageAllowed: license.isNoQualifiedMortgageAllowed,
        mortgagee: license.mortgagee,
        licenseType: license.licenseType,
      },
    }),
    {},
  );
});

const getLicensedStatesValues = createSelector(getLicensedStates, Object.values);

export const getFilteredLicensedStates = createSelector(
  getDebouncedSearchValue,
  getLicensedStatesValues,
  searchItems(license => [license.stateCode]),
);
